import { path, pathOr } from 'ramda';

import type { Notification } from '@frontend/api/src/notifications/types';
import { Text, Box } from '@frontend/components';

import { InteractiveFlex } from 'components/lib2/InteractiveContainers';

import NotificationDateAndBusinessName from './NotificationDateAndBusinessName';
import NotificationThumbnail from './NotificationThumbnail';
import ToastCloseButton from './ToastCloseButton';

const NotificationToast = ({
  notification,
  groupId,
  isThumbnail,
  onClose,
  thumbnailBlob,
  userGroupMembers,
}: {
  notification: Notification;
  groupId: number;
  isThumbnail: boolean;
  onClose: () => void;
  thumbnailBlob: Blob | null | undefined;
  userGroupMembers: string[];
}) => {
  const { id: notificationGroupId } = notification.group;

  const pathToResource = notification?.relativeUrl || '';

  let title = pathOr(false, ['title'], notification)
    ? `${path(['title'], notification)}: `
    : '';

  const msg = pathOr(false, ['body'], notification)
    ? `${path(['body'], notification)}`
    : '';

  if (!msg) title = title.slice(0, -2);

  const handleClose = (e: React.MouseEvent<Element, MouseEvent>) => {
    e.preventDefault();
    e.stopPropagation();

    onClose();
  };

  return (
    <Box
      marginBottom={2}
      border="1px solid"
      borderColor="separator.border"
      borderRadius="md"
    >
      <InteractiveFlex
        justifyContent="space-between"
        padding={2}
        paddingRight={4}
        as={'a'}
        href={pathToResource}
      >
        <Box marginRight={1} display="flex" flexDirection="column" width="100%">
          <Text fontWeight="heavy" size="sm">
            {title}
          </Text>
          {msg && <Text size="sm">{msg}</Text>}
          <NotificationDateAndBusinessName
            notification={notification}
            isCurrent={groupId === notificationGroupId}
            isFlash={true}
            userGroupMembers={userGroupMembers}
          />
        </Box>
        {isThumbnail && (
          <NotificationThumbnail
            notification={notification}
            thumbnailBlob={thumbnailBlob}
          />
        )}
      </InteractiveFlex>
      <ToastCloseButton handleClose={handleClose} />
    </Box>
  );
};

export default NotificationToast;
